export const DATE_FORMAT_YMD = "YYYY-MM-DD";
export const DATE_FORMAT_NL_NLS = "dddd D MMMM YYYY";

export const DELIVERY_ID_STANDARD = 14645965;
export const DELIVERY_ID_MORNING = 14645974;
export const DELIVERY_ID_AFTERNOON = 14645981;
export const DELIVERY_ID_EVENING = 14646028;
export const DELIVERY_ID_SUNDAY = 19536998;

export const DELIVERY_IDS = [
  DELIVERY_ID_STANDARD,
  DELIVERY_ID_MORNING,
  DELIVERY_ID_AFTERNOON,
  DELIVERY_ID_EVENING,
  DELIVERY_ID_SUNDAY
];

export const CARD_ID_RIBBON = 3539232;

export const CARD_IDS = [CARD_ID_RIBBON];

export const VK_RETURN = 13;
export const VK_ESCAPE = 27;

export const KEY_CODES = {
  VK_RETURN,
  VK_ESCAPE
};

export default {
  DATE_FORMAT_YMD,
  DELIVERY_IDS,
  KEY_CODES
};
